import { render, staticRenderFns } from "./examenPulpar.vue?vue&type=template&id=73aa723e"
import script from "./examenPulpar.vue?vue&type=script&lang=js"
export * from "./examenPulpar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports